module.exports = __webpack_public_path__ + "static/media/cover-portable-fire-extinguishers.a1455b36.jpg";